import { render, staticRenderFns } from "./CharacterBlacklist.vue?vue&type=template&id=55580969&scoped=true&"
import script from "./CharacterBlacklist.vue?vue&type=script&lang=js&"
export * from "./CharacterBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./CharacterBlacklist.vue?vue&type=style&index=0&id=55580969&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55580969",
  null
  
)

export default component.exports